import {Component, EventEmitter, Input, Output} from "@angular/core";
import {ScreenLayoutEditorModel} from "../screen-layout-editor.model";
import {ScreenLayoutMenuData} from "../../../screen-layout.data";

/**
 * Button within a screen layout menu bar
 */
@Component({
    selector: "wbo-screen-layout-menu-bar-button",
    templateUrl: "./screen-layout-menu-bar-button.component.html",
    styleUrls: ["./screen-layout-menu-bar-button.component.scss"]
})
export class ScreenLayoutMenuBarButtonComponent {
    @Input() menu: ScreenLayoutMenuData;
    @Input() showLeftCommands: boolean;
    @Input() showRightCommands: boolean;
    @Output() public commandsToggled$: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() public navigated$: EventEmitter<any> = new EventEmitter<any>();

    isLeftCommandsToggled: boolean;
    isRightCommandsToggled: boolean;

    constructor(public model: ScreenLayoutEditorModel) {
    }

    leftCommandsToggled(toggled: boolean) {
        this.isLeftCommandsToggled = toggled;
        this.commandsToggled$.emit(this.isLeftCommandsToggled || this.isRightCommandsToggled);
    }

    rightCommandsToggled(toggled: boolean) {
        this.isRightCommandsToggled = toggled;
        this.commandsToggled$.emit(this.isLeftCommandsToggled || this.isRightCommandsToggled);
    }
}
